/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import { Cell } from "gui/grid/cell";
import { EntriesList } from "gui/entries/entries-list";
import { Entry } from "lib/entries/types";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { Subtitle } from "gui/subtitle/subtitle";

export const Entries: React.FC<{
  entries: Entry[];
  icon?: string;
  title?: string;
  more?: string;
  link?: string;
}> = (props) => {
  if (props.entries.length === 0) {
    return null;
  }

  return (
    <Grid revealOnScroll gaps>
      <Subtitle text={props.title} icon={props.icon}>
        {props.link && props.more && (
          <a href={props.link}>
            {props.more}
            <Icon icon="arrow-right" />
          </a>
        )}
      </Subtitle>
      <Cell>
        <EntriesList entries={props.entries} size="sm" color1 avatar />
      </Cell>
    </Grid>
  );
};
